import { useContext } from 'react'
import { accessibility, ROLES } from '../../utils/Utils'
import { AppContext } from '../../store/AppProvider'

export const Accessibility = ({ feature, children }) => {
    const { activeRole } = useContext(AppContext)
    const hasRole = ROLES?.[activeRole]
    const hasAccess = Boolean(accessibility(feature, hasRole))
    return (
        <>
            {hasAccess ? children : <div aria-hidden="true" />}
        </>
    )
}
